import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Pages for staff with access to an area (utils/access.js), at least at
// `level`. `clubAdmin` pages (roles) are for Club admins only. Anyone else
// is sent home. `anyOf` ([[area, level], ...]) lets in anyone with one of
// them, for pages the server opens to more than one area.
export default function AccessRoute({ area, level = 'VIEW', clubAdmin = false, staff = false, anyOf = null }) {
  const { user, loading, can, isClubAdmin, isStaff } = useAuth();
  const location = useLocation();

  if (loading) return <div className="loading"><div className="spinner"></div></div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  // A super admin outside any club passes, as before (the server decides)
  if (user.role === 'SUPER_ADMIN') return <Outlet />;

  const allowed = clubAdmin ? isClubAdmin
    : staff ? isStaff
      : anyOf ? anyOf.some(([a, l]) => can(a, l))
        : can(area, level);
  if (!allowed) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
